import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import CardsRenderWrapper from './CardsRenderWrapper';
import { BANNER } from '../../constants';
import Wrapper from '../../../Wrapper';
import { splitChildren, appendImages } from '../../../../helpers';
import { getPropsToDisplayModifiers } from '../../../../utils';
import ListPagination from '../Pagination';
import { LOAD_MORE } from '../../../../constants';
import { useGetImages } from '../../../../hooks';

const CardsRender = ({
  orderedListData,
  gridModifier,
  children,
  entity,
  banner,
  omitWrappers,
  propsToDisplay,
  paginationType,
  parent,
  hasBanner,
  gtmData,
  itemsToDisplay,
  ...props
}) => {
  const { name } = props;
  const dataForGtm = gtmData || orderedListData;

  const { regularChildren, gtmChildren } = splitChildren(children, dataForGtm, entity, {
    name
  });

  const bannerProps = banner
    ? { parent, hasBanner, entity, propsToDisplay, ...banner, type: BANNER }
    : null;

  const propsToDisplayModifiers = getPropsToDisplayModifiers(propsToDisplay);
  const imageIds = itemsToDisplay.map(({ imageId }) => imageId).filter(Boolean);
  const { data: imagesData, loading: imagesLoading } = useGetImages(imageIds, true);

  if (imagesLoading) return '';

  const updatedListWithImages = appendImages(imagesData, orderedListData, itemsToDisplay);
  const WrapperToUse = omitWrappers ? Fragment : Wrapper;

  return (
    <>
      <WrapperToUse className="list list--compact">
        <CardsRenderWrapper
          orderedListData={updatedListWithImages}
          listProps={props}
          bannerProps={bannerProps}
          cardChildren={regularChildren}
          gtmChildren={gtmChildren}
          omitWrappers={omitWrappers}
          propsToDisplay={propsToDisplay}
          propsToDisplayModifiers={propsToDisplayModifiers}
          gridModifier={gridModifier}
          entity={entity}
          parent={parent}
          {...props}
        />
      </WrapperToUse>

      {paginationType === LOAD_MORE && (
        <ListPagination paginationType={paginationType} parent={parent} {...props} />
      )}
    </>
  );
};

CardsRender.propTypes = {
  name: PropTypes.string.isRequired,
  parent: PropTypes.object.isRequired,
  orderedListData: PropTypes.array.isRequired,
  propsToDisplay: PropTypes.array.isRequired,
  paginationType: PropTypes.string.isRequired,
  hasBanner: PropTypes.bool,
  banner: PropTypes.object,
  omitWrappers: PropTypes.bool,
  gridModifier: PropTypes.string,
  entity: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  gtmData: PropTypes.array,
  itemsToDisplay: PropTypes.array
};

CardsRender.defaultProps = {
  gridModifier: '',
  children: null,
  hasBanner: false,
  banner: null,
  omitWrappers: false,
  gtmData: null,
  itemsToDisplay: []
};

export default CardsRender;
